import { render, staticRenderFns } from "./consign.vue?vue&type=template&id=45cc2cb4&scoped=true&"
import script from "./consign.vue?vue&type=script&lang=js&"
export * from "./consign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc2cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cc2cb4')) {
      api.createRecord('45cc2cb4', component.options)
    } else {
      api.reload('45cc2cb4', component.options)
    }
    module.hot.accept("./consign.vue?vue&type=template&id=45cc2cb4&scoped=true&", function () {
      api.rerender('45cc2cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stock/detail/consign.vue"
export default component.exports